import React from 'react';
import './Officers.css'; // Import the CSS file

const Officers = () => {
  return (
    <>
        <div className="master-table">
                <div className="master-row">
                    <div className="master-column master-section">
                    <h1>Officers</h1>
                    <p>
                        The club has five officers that lead and represent the club.  These officers are elected at our January 
                        meeting and have a term of one year, with a maximum of two consecutive terms. Below are our officers
                        for this year.
                    </p>
                    <div className="officer-group">
                        <h2 className="officer-title">President - Mark Kunzelmann</h2>
                        <table>
                            <tr>
                                <td>
                                    <div>
                                        <a href="https://www.instagram.com/stlbrews">
                                            <img  src="/assets/Mark Pic.jpg" alt="president"  className="officer-img"/>
                                        </a>
                                    </div>
                                </td>
                                <td>
                                    <div className="officer-text">
                                        <p>
                                            Mark developed a taste for good beer in college and started 
                                            brewing his own in 1993. These were 5-gallon extract batches 
                                            brewed on a stovetop. Before long, he was incorporating 
                                            ever-increasing amounts of base and specialty malts to improve 
                                            the quality and flavor of his beers.
                                        </p>
                                        <p>
                                            In 1998, while living in Portland, Oregon, he made the jump to 
                                            all-grain brewing and never looked back.  He still uses a 
                                            stovetop for the occasional decoction mash but otherwise, 
                                            he operates an electric HERMS brewery in his basement.
                                        </p>
                                        <p>
                                            Mark is a BJCP beer, mead and cider judge, and he regularly 
                                            competes in local and national brewing competitions.
                                        </p>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>

                    <div className="officer-group">
                        <h2 className="officer-title">Vice President - Tim Fahrner</h2>
                        <table>
                            <tr>
                                <td>
                                    <div>
                                        <a href="https://www.instagram.com/stlbrews">
                                            <img  src="/assets/Tim Pic.jpg" alt="vice president"  className="officer-img"/>
                                        </a>
                                    </div>
                                </td>
                                <td>
                                    <div className="officer-text">
                                        <p>
                                            Tim has been brewing beer at home since 1989, and joined the St. Louis Brews 
                                            in 1990. The poor quality of imported beers led him to try to replicate 
                                            fresh examples of favorite styles at home. The club’s influence quickly 
                                            brought his level of brewing from strictly extract batches to all-grain 
                                            versions of challenging styles (such as malty German lagers). Since that 
                                            time, he has been brewing approximately 10-12 batches a year, spanning 
                                            the gamut of styles from British ales to German lagers to sour Lambic/strong 
                                            Flemish ales.
                                        </p>
                                        <p>
                                            Tim is also a Recognized BJCP beer judge, beekeeper, and meadmaker.
                                        </p>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>

                    <div className="officer-group">
                        <h2 className="officer-title">Treasurer - Ryan Schuetz</h2>
                        <table>
                            <tr>
                                <td>
                                    <div>
                                        <a href="https://www.instagram.com/stlbrews">
                                            <img  src="/assets/Ryan Pic.jpg" alt="treasurer"  className="officer-img"/>
                                        </a>
                                    </div>
                                </td>
                                <td>
                                    <div className="officer-text">
                                        <p>
                                            Ryan began his homebrewing journey in 2003, starting out with extract kits 
                                            brewed on the kitchen stove. The thrill of crafting his own beer quickly grew, 
                                            inspiring him to upgrade to a 10-gallon all grain system in 2005. Since then, 
                                            He&#39;s honed his skills and experimented with a variety of brewing techniques, 
                                            always striving to perfect each batch.
                                        </p>
                                        <p>
                                            His favorite styles to brew include Wee Heavy, German Hefeweizen, California 
                                            Common, and a range of Belgian and German classics. He has a particular passion 
                                            for drinking barrel-aged beers, savoring their complex flavors. He also enjoys 
                                            exploring new home brewery gadgets, constantly seeking ways to enhance his home 
                                            brewery.
                                        </p>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>

                    <div className="officer-group">
                        <h2 className="officer-title">Secretary - Kent Robertson</h2>
                        <table>
                            <tr>
                                <td>
                                    <div>
                                        <a href="https://www.instagram.com/stlbrews">
                                            <img  src="/assets/Kent Pic.jpg" alt="secretary"  className="officer-img"/>
                                        </a>
                                    </div>
                                </td>
                                <td>
                                    <div className="officer-text">
                                        <p>
                                            Kent has been homebrewing for more than 20 years, and has
                                            been an active Brews member for most of that time. His love 
                                            of homebrewing has led Kent to hold several positions over
                                            the years as an officer of the club, and he is also the owner
                                            of Missouri Malt.
                                        </p>
                                        <p>
                                            He is interested in lager brewing, especially
                                            German lagers, and is currently working on perfecting
                                            decoction mashing.  Kent's favorite beer tasting experience
                                            is drinking lager <i>vom fass</i>
                                            in a biergarten filled with people and live music.
                                        </p>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>

                    <div className="officer-group">
                        <h2 className="officer-title">Brewmeister - Brad Stoneking</h2>
                        <table>
                            <tr>
                                <td>
                                    <div>
                                        <a href="https://www.instagram.com/stlbrews">
                                            <img  src="/assets/Brad Pic.jpg" alt="brewmeister"  className="officer-img"/>
                                        </a>
                                    </div>
                                </td>
                                <td>
                                    <div className="officer-text">
                                        <p>
                                            Brad has had a preference for full flavor beer since 
                                            his youth but didn&#39;t get into home brewing until his daughter 
                                            and son-in-law gifted him a home brew extract kit.  That was 
                                            in 2013 and was the last extract kit he used.  He immediately 
                                            went to whole grain 5 gallon batches.  
                                        </p>
                                        <p>
                                            He made the jump to 10 gallon batches when both daughters 
                                            gifted him a 12 gallon boil kettle. He brews with propane 
                                            and an Igloo cooler mash tun.  He has averaged 100 gallons 
                                            per year since then with kegs going to the daughter in 
                                            Minnesota, local brew fests, and his three tap Keezer.  
                                        </p>
                                        <p>    
                                            He is now retired and plans to occupy his time with family 
                                            trips, serving at beer fests, and bicycling.  
                                        </p>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    </div>
                </div>
            </div>
  
    </>
  );
};

export default Officers;
